import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from 'src/app/model/product';
import { ProductService } from '../products/services/product.service';
import { AppModeService } from 'src/app/services/app-mode.service';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.css'],
})
export class WishlistComponent {
  products: any[] = [];
  private readonly wishlistKey = 'wembely_wishlist_ids';

  constructor(
    private readonly productService: ProductService,
    private readonly router: Router,
    public readonly appModeService: AppModeService
  ) {}

  ngOnInit(): void {
    this.loadWishlistProducts();
  }

  get itemCount(): number {
    return this.products.length;
  }

  goBack(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/profile`);
  }

  viewProduct(id: string): void {
    this.router.navigate(['/products', id]);
  }

  trackByProduct(_: number, item: { id: string }): string {
    return item.id;
  }

  private loadWishlistProducts(): void {
    const wishlistIds = this.readWishlistIds();
    if (!wishlistIds.length) {
      this.products = [];
      return;
    }

    this.productService.getProducts().subscribe((res: Product[]) => {
      const filtered = res.filter((product) => wishlistIds.includes(product.id));
      this.products = this.productService.mapToCardProducts(filtered);
    });
  }

  private readWishlistIds(): string[] {
    if (typeof window === 'undefined') {
      return [];
    }

    const raw = localStorage.getItem(this.wishlistKey);
    if (!raw) {
      return [];
    }

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
